define('rebrush/components/blocks/raster-grid',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'lodash',
    'lucid',
    'json!rebrush/etc/breakpoints.json',
    'enquire'
], function(
    $,
    Component,
    BEM,
    _,
    lucidJS,
    Breakpoints,
    enquire
) {
    var BLOCK_NAME = 'raster-grid';
    var BLOCK_DATA_ATTRIBUTE_MATRIX = 'grid-matrix';
    var TILE_DATA_ATTRIBUTE_CONFIG = 'grid-config';
    var MODE_MOBILE = 'mobile';
    var MODE_TABLET = 'tablet';
    var MODE_DESKTOP = 'desktop';

    // TODO remove
    var mockData = {
        tiles: [{
            mobile: {
                size: [1, 1],
                offset: [0, 0]
            },
            tablet: {
                size: [2, 1],
                offset: [0, 0]
            },
            desktop: {
                size: [2, 2],
                offset: [1, 0]
            }
        }, {
            mobile: {
                size: [1, 1],
                offset: [0, 1]
            },
            tablet: {
                size: [1, 1],
                offset: [0, 1]
            },
            desktop: {
                size: [1, 1],
                offset: [0, 0]
            }
        }, {
            mobile: {
                size: [1, 1],
                offset: [0, 2]
            },
            tablet: {
                size: [1, 1],
                offset: [1, 1]
            },
            desktop: {
                size: [1, 1],
                offset: [0, 1]
            }
        },



        {
            mobile: {
                size: [1, 1],
                offset: [0, 3]
            },
            tablet: {
                size: [1, 1],
                offset: [0, 2]
            },
            desktop: {
                size: [2, 1],
                offset: [0, 2]
            }
        }, {
            mobile: {
                size: [1, 1],
                offset: [0, 4]
            },
            tablet: {
                size: [1, 1],
                offset: [1, 2]
            },
            desktop: {
                size: [1, 1],
                offset: [1, 2]
            }
        }]
    };

    // TODO remove
    function generateMockTiles(parent) {
        parent = $(parent);

        _.forEach(mockData.tiles, function(tileData, i) {
            var element = $('<div class="' + BEM.buildElementClassname(BLOCK_NAME, 'tile') + '"></div>');
            // var inner = $('<div class="' + BEM.buildElementClassname(BLOCK_NAME, 'tile-inner') + '"></div>');
            // inner.appendTo(element);

            var dummyContent = $('<div class="b_raster-grid-item-image"><div class="b_raster-grid-item-image__title">Lorem ipsum</div></div>');
            dummyContent.appendTo(element);

            element.attr('data-tile-id', i);
            element.data(TILE_DATA_ATTRIBUTE_CONFIG, tileData);
            parent.append(element);
        });
    }

    // TODO remove
    function generateMockGridMatrix(block) {
        block = $(block);
        block.data(BLOCK_DATA_ATTRIBUTE_MATRIX, {
            mobile: {
                columns: 1
            },
            tablet: {
                columns: 2
            },
            desktop: {
                columns: 3
            }
        });
    }

    // TODO remove
    function generateMockBlock() {
        var block = $('<div class="' + BEM.buildBlockClassname(BLOCK_NAME) +  '"></div>');

        generateMockTiles(block);
        generateMockGridMatrix(block);

        $('.b_main-container__col1-col-main .container:first').append(block);
    }

    function Matrix() {
        this.rows = [];
    }
    Matrix.prototype = {
        addRow: function(row) {
            this.rows.push(row);
            return this;
        },

        getRows: function() {
            return this.rows;
        }
    };

    function Row() {
        this.cells = [];
    }
    Row.prototype = {
        addCell: function(cell) {
            this.cells.push(cell);
            return this;
        },

        getCells: function() {
            return this.cells;
        }
    };

    function Cell() {
        this.tiles = [];
    }
    Cell.prototype = {
        addTile: function(tile) {
            this.tiles.push(tile);
            return this;
        },

        getTiles: function() {
            return this.tiles;
        }
    };

    function Grid(el) {
        lucidJS.EventEmitter.call(this);

        this.block = BEM.block(el);
        this.tiles = this.block.getElements('tile');
        this.config = {
            matrix: this.block.data(BLOCK_DATA_ATTRIBUTE_MATRIX)
        };

        this.mode = MODE_MOBILE;

        // this.render('desktop');
        this.watchBreakpoints();
    }

    Grid.prototype = _.create(new lucidJS.EventEmitter(), {
        watchBreakpoints: function() {
            enquire.register('(max-width: ' + (Breakpoints.mobile) + 'px)', {
                match: _.bind(function() {
                    this.render(MODE_MOBILE);
                }, this)
            });
            enquire.register('(min-width: ' + (Breakpoints.mobile + 1) + 'px) and (max-width: ' + (Breakpoints.sm) + 'px)', {
                match: _.bind(function() {
                    this.render(MODE_TABLET);
                }, this)
            });

            enquire.register('(min-width: ' + (Breakpoints.sm + 1) + 'px)', {
                match: _.bind(function() {
                    this.render(MODE_DESKTOP);
                }, this)
            });
        },

        render: function(mode) {
            if (this.mode === mode) {
                return;
            }

// console.log('RENDER ' + mode);

            var matrix = this.calculateMatrix(mode);
            this.clear();

            _.forEach(matrix.getRows(), _.bind(function(row) {
                var rowElement = this.createRow();

                _.forEach(row.getCells(), _.bind(function(cell) {
                    var cellElement = this.createCell(),
                        tiles = cell.getTiles();

                    var tileData = this.getTileData(_.head(tiles), mode),
                        size = tileData.size;

                    cellElement.bemAddModifier('width-' + size[0]);

                    _.forEach(tiles, _.bind(function(tile) {
                        var tileData = this.getTileData(tile, mode),
                            size = tileData.size,
                            tileElementClassname = BEM.buildElementClassname(BLOCK_NAME, 'tile');

                        tile = $(tile);

                        tile.attr('class', _.filter(tile.attr('class').split(' '), function(c) {
                            return !(new RegExp('^' + tileElementClassname + '--size-\\d+-\\d+')).match(c);
                        }).join(' '));

                        tile.bemAddModifier('size-' + size[0] + '-' + size[1]);

                        tile.appendTo(cellElement);
                    }, this));

                    cellElement.appendTo(rowElement);
                }, this));

                rowElement.appendTo(this.block);
            }, this));

            this.mode = mode;

            this.trigger('render');

            this.block.bemAddModifier('rendered');
        },

        getTileData: function(tile, mode) {
            var tileData = $(tile).data(TILE_DATA_ATTRIBUTE_CONFIG),
                data = _.get(tileData, mode, _.get(tileData, 'mobile', null));

            return data;
        },

        calculateMatrix: function(mode) {
            var coordinates = _.reduce(this.tiles.get(), _.bind(function(result, tile, tileId) {
                var data = this.getTileData(tile, mode),
                    size = data.size,
                    offset = data.offset,
                    width = Math.max(size[0], 1),
                    height = Math.max(size[1], 1);

                _.times(width, function(i) {
                    var x = parseInt(offset[0], 10) + parseInt(i, 10);
                    _.times(height, function(j) {
                        var y = parseInt(offset[1], 10) + parseInt(j, 10);

                        if ('undefined' === typeof result[x]) {
                            result[x] = [];
                        }

                        result[x][y] = tile;
                    });
                });

                return result;
            }, this), []);

            var lineCoordinates = _.reduce(coordinates, function(result, col, x) {
                _.forEach(col, function(tile, y) {
                    if ('undefined' === typeof result[y]) {
                        result[y] = [];
                    }

                    if ('console' in window && 'undefined' !== typeof result[y][x]) {
                        console.warn('Raster grid tile collision detected');
                    }

                    result[y][x] = tile;
                });

                return result;
            }, []);


            var rows = [];
            var rowBuffer = [];
            _.forEach(lineCoordinates, function(line, y) {
                if (rowBuffer.length) {
                    var previousLine = _.last(rowBuffer);

                    if (_.intersection(previousLine, line).length === 0) {
                        rows.push(rowBuffer);
                        rowBuffer = [];
                    }
                }

                rowBuffer.push(line);
            });

            if (rowBuffer.length) {
                rows.push(rowBuffer);
            }



            var matrix = _.reduce(rows, function(m, lines) {
                var row = new Row();
                var placedTiles = [];
                var cells = [];

                _.forEach(lines, function(line, y) {
                    _.forEach(line, function(tile, x) {
                        if ('undefined' === typeof tile || 0 <= placedTiles.indexOf(tile)) {
                            return;
                        }

                        var cell = cells[x] || new Cell();

                        cell.addTile(tile);
                        cells[x] = cell;
                        placedTiles.push(tile);
                    });
                });

                _.forEach(cells, function(cell) {
                    if ('undefined' !== typeof cell) {
                        row.addCell(cell);
                    }
                });

                m.addRow(row);

                return m;
            }, new Matrix());

            return matrix;
        },

        clear: function() {
            this.tiles.detach();
            this.block.empty();
        },

        createRow: function() {
            return $('<div class="' + BEM.buildElementClassname(BLOCK_NAME, 'row') + '"></div>');
        },

        createCell: function() {
            return $('<div class="' + BEM.buildElementClassname(BLOCK_NAME, 'cell') + '"></div>');
        },

        createTile: function() {
            return $('<div class="' + BEM.buildElementClassname(BLOCK_NAME, 'tile') + '"></div>');
        }
    });


    return Component.create({
        blocks: null,

        $init: function() {
            var self = this;
            // generateMockBlock(); // TODO remove
            this.blocks = BEM.block(BLOCK_NAME);
            this.blocks.each(function() {
                var grid = new Grid(this);

                grid.on('render', function() {
                    self.hub.trigger('ui.component.rendering.after', {
                        component: self,
                        grid: grid
                    });
                });
            });
        }
    });
});
